<template>
  <div
    class="spm-key-card relative bg-gray-100"
  >
    <div class="flex justify-content-between align-items-center gap-2">
      <span class="font-medium">{{ secretKey }}</span>
      <Button
        class="p-button-secondary spm-key-card__copy"
        icon="far fa-clipboard"
        :label="t('copy')"
        severity="secondary"
        text
        @click="copyToClipboard"
      />
    </div>
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
} from 'vue';
import Button from 'primevue/button';

import { useI18n } from 'vue-i18n';

import { showToastSuccess } from '@/helpers';

export default defineComponent({
  name: 'SpmKeyCard',

  components: {
    Button,
  },

  props: {
    secretKey: {
      type: String,
      required: true,
    },
  },

  setup(props) {
    const { t } = useI18n();

    const copyToClipboard = () => {
      navigator.clipboard.writeText(props.secretKey);
      showToastSuccess(t('copiedToClipboard'));
    };

    return {
      t,
      copyToClipboard,
    };
  },
});
</script>

<style lang="scss" scoped>
.spm-key-card {
  padding: 0.25rem 0.5rem;
  border: 1px solid transparent;
  border-radius: .25rem;
}

.spm-key-card__copy {
  font-size: 0.85rem;
  padding: 0.35rem 0.65rem;
  white-space: nowrap;
}
</style>
